module.exports = require("./lib/_stream_duplex.js")



/*****************
 ** WEBPACK FOOTER
 ** (webpack)/~/node-libs-browser/~/readable-stream/duplex.js
 ** module id = 296
 ** module chunks = 46 47
 **/